import { useLauncherInBottomLeft } from '@/components/AiAnalyst/useLauncherInBottomLeft'
import { Toaster } from '@/components/ui/sonner'

/**
 * The app's toasts. They sit bottom-left, out of the way of the AI Analyst's
 * launcher in its bottom-right home; when someone parks the launcher in the
 * bottom-left corner instead, the toasts take the bottom-right.
 */
export function AppToaster() {
  const launcherBottomLeft = useLauncherInBottomLeft()
  return <Toaster position={launcherBottomLeft ? 'bottom-right' : 'bottom-left'} />
}
